export let programCreateCoverImage = null;
export let feedCreateCoverImage = null;
export let feedCreateCoverVideo = null;
export let selectedStartDate = null;
export let selectedEndDate = null;
export let programQuestionBulkUploadFile = null;
// export let feedUploadProgress = 0;
// User Bulk Upload
export let userBulkUploadFile = null;

export const setApiValue = (payload) => {
  if (payload && payload.type) {
    if (payload.type === "programCreateCoverImage") {
      programCreateCoverImage = payload.data;
    } else if (payload.type === "feedCreateCoverImage") {
      feedCreateCoverImage = payload.data;
    } else if (payload.type === "feedCreateCoverVideo") {
      feedCreateCoverVideo = payload.data;
    } else if (payload.type === "selectedStartDate") {
      selectedStartDate = payload.data;
    } else if (payload.type === "feedUploadProgress") {
      localStorage.setItem("feedUploadProgress", payload.data);
      window.dispatchEvent(new Event("DT_TA_Progress"));
    } else if (payload.type === "quesUploadWindowProgress") {
      localStorage.setItem("quesUploadWindowProgress", payload.data);
      window.dispatchEvent(new Event("DT_TA_QuesUpload_Progress"));
    } else if (payload.type === "programQuestionBulkUploadFile") {
      programQuestionBulkUploadFile = payload.data;
    }
    // User Bulk Upload
    else if (payload.type === "userUploadWindowProgress") {
      localStorage.setItem("userUploadWindowProgress", payload.data);
      window.dispatchEvent(new Event("DT_TA_UserUpload_Progress"));
    }
  }
};

export const resetAssetsValue = (payload) => {
  programCreateCoverImage = null;
  feedCreateCoverImage = null;
  feedCreateCoverVideo = null;
};

export const standardUrlFetch = (url) => {
  if (url) {
    return new Promise(function (resolve, reject) {
      let request = new XMLHttpRequest();
      request.open("GET", url, true);
      request.responseType = "blob";
      request.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(request.response);
        } else {
          reject({
            status: this.status,
            statusText: request.statusText,
          });
        }

        request.onerror = function () {
          reject({
            status: this.status,
            statusText: request.statusText,
          });
        };
      };
      request.send();
    });
  }
};
